<div class="preferences-page">
  <div class="preferences-header">
    <h1 class="page-title">Preferences</h1>
  </div>

  <div class="tabs">
    <div class="tab-bar">
      <button class="tab" [class.tab-active]="activeTab === 'user'" (click)="selectTab('user')">
        My Preferences
      </button>
      <button class="tab" [class.tab-active]="activeTab === 'company'" (click)="selectTab('company')" *ngIf="isAdmin || isSuperAdmin">
        Company Settings
      </button>
    </div>

    <!-- ═══════════════════ MY PREFERENCES ═══════════════════ -->
    <div class="panel" *ngIf="activeTab === 'user'">
      <form (ngSubmit)="submitUser()" #userPrefForm="ngForm">

        <!-- General -->
        <div class="settings-section">
          <div class="section-title">General</div>

          <div class="field-row" [class.field-locked]="isLocked('language')">
            <label class="field-label">
              Language
              <span class="lock-icon" *ngIf="isLocked('language')" title="Locked by company">🔒</span>
            </label>
            <div class="field-control">
              <select name="language" [(ngModel)]="language" class="select-input" [disabled]="isLocked('language')">
                <option *ngFor="let l of languageOptions" [value]="l.value">{{ l.label }}</option>
              </select>
            </div>
          </div>

          <div class="field-row" [class.field-locked]="isLocked('measurementSystem')">
            <label class="field-label">
              Measurement System
              <span class="lock-icon" *ngIf="isLocked('measurementSystem')" title="Locked by company">🔒</span>
            </label>
            <div class="field-control radio-group">
              <label class="radio-label">
                <input type="radio" name="measurementSystem" value="metric" [(ngModel)]="measurementSystem" [disabled]="isLocked('measurementSystem')" />
                Metric
              </label>
              <label class="radio-label">
                <input type="radio" name="measurementSystem" value="imperial" [(ngModel)]="measurementSystem" [disabled]="isLocked('measurementSystem')" />
                Imperial
              </label>
            </div>
          </div>

          <div class="field-row">
            <label class="field-label">Theme</label>
            <div class="field-control radio-group">
              <label class="radio-label"><input type="radio" name="theme" value="light" [(ngModel)]="theme" /> Light</label>
              <label class="radio-label"><input type="radio" name="theme" value="dark"  [(ngModel)]="theme" /> Dark</label>
              <label class="radio-label"><input type="radio" name="theme" value="auto"  [(ngModel)]="theme" /> Auto</label>
            </div>
          </div>

          <div class="field-row">
            <label class="field-label">Rows per page</label>
            <div class="field-control inline-unit">
              <input type="number" name="rowsPerPage" [(ngModel)]="rowsPerPage" class="number-input" min="10" max="100" />
              <span class="range-unit">rows</span>
            </div>
          </div>
        </div>

        <!-- Charts -->
        <div class="settings-section">
          <div class="section-title">Charts</div>

          <div class="field-row" [class.field-locked]="isLocked('temp3DRange')">
            <label class="field-label">
              3D Temp Range
              <span class="lock-icon" *ngIf="isLocked('temp3DRange')" title="Locked by company">🔒</span>
            </label>
            <div class="field-control range-row">
              <label class="range-label">Min</label>
              <input type="number" name="temp3DRangeMin" [(ngModel)]="temp3DRangeMin" class="number-input" [disabled]="isLocked('temp3DRange')" />
              <span class="range-unit">°C</span>
              <label class="range-label">Max</label>
              <input type="number" name="temp3DRangeMax" [(ngModel)]="temp3DRangeMax" class="number-input" [disabled]="isLocked('temp3DRange')" />
              <span class="range-unit">°C</span>
            </div>
          </div>

          <div class="field-row">
            <label class="field-label">3D Time Mode</label>
            <div class="field-control radio-group">
              <label class="radio-label"><input type="radio" name="timeIn3DGraph" value="relative" [(ngModel)]="timeIn3DGraph" /> Relative</label>
              <label class="radio-label"><input type="radio" name="timeIn3DGraph" value="absolute" [(ngModel)]="timeIn3DGraph" /> Absolute</label>
            </div>
          </div>

          <div class="field-row" [class.field-locked]="isLocked('chartsColorPalette')">
            <label class="field-label">
              Color Palette
              <span class="lock-icon" *ngIf="isLocked('chartsColorPalette')" title="Locked by company">🔒</span>
            </label>
            <div class="field-control">
              <select name="chartsColorPalette" [(ngModel)]="chartsColorPalette" class="select-input" [disabled]="isLocked('chartsColorPalette')">
                <option *ngFor="let p of colorPaletteOptions" [value]="p.value">{{ p.label }}</option>
              </select>
            </div>
          </div>

          <div class="field-row">
            <label class="field-label">Auto-refresh</label>
            <div class="field-control inline-unit">
              <input type="number" name="chartsAutoRefreshIntervalS" [(ngModel)]="chartsAutoRefreshIntervalS" class="number-input" min="0" max="300" />
              <span class="range-unit">seconds (0 = off)</span>
            </div>
          </div>
        </div>

        <!-- Project list -->
        <div class="settings-section">
          <div class="section-title">Project List</div>

          <div class="field-row">
            <label class="field-label">Default status filter</label>
            <div class="field-control">
              <select name="projectListDefaultStatusFilter" [(ngModel)]="projectListDefaultStatusFilter" class="select-input">
                <option *ngFor="let o of statusFilterOptions" [value]="o.value">{{ o.label }}</option>
              </select>
            </div>
          </div>

          <div class="field-row">
            <label class="field-label">Default date range</label>
            <div class="field-control">
              <select name="projectListDefaultDateRange" [(ngModel)]="projectListDefaultDateRange" class="select-input">
                <option *ngFor="let o of dateRangeOptions" [value]="o.value">{{ o.label }}</option>
              </select>
            </div>
          </div>
        </div>

        <!-- Notifications -->
        <div class="settings-section">
          <div class="section-title">Notifications</div>

          <div class="field-row" [class.field-locked]="isLocked('notificationsEmailEnabled')">
            <label class="field-label">
              Email alerts
              <span class="lock-icon" *ngIf="isLocked('notificationsEmailEnabled')" title="Locked by company">🔒</span>
            </label>
            <div class="field-control">
              <label class="toggle-label">
                <input type="checkbox" name="notificationsEmailEnabled" [(ngModel)]="notificationsEmailEnabled" [disabled]="isLocked('notificationsEmailEnabled')" />
                <span class="toggle-text">{{ notificationsEmailEnabled ? 'Enabled' : 'Disabled' }}</span>
              </label>
            </div>
          </div>

          <div class="field-row" [class.field-locked]="isLocked('notificationsRealtimeAlerts')">
            <label class="field-label">
              Realtime alerts
              <span class="lock-icon" *ngIf="isLocked('notificationsRealtimeAlerts')" title="Locked by company">🔒</span>
            </label>
            <div class="field-control">
              <label class="toggle-label">
                <input type="checkbox" name="notificationsRealtimeAlerts" [(ngModel)]="notificationsRealtimeAlerts" [disabled]="isLocked('notificationsRealtimeAlerts')" />
                <span class="toggle-text">{{ notificationsRealtimeAlerts ? 'Enabled' : 'Disabled' }}</span>
              </label>
            </div>
          </div>

          <div class="field-row">
            <label class="field-label">Notify on preference overwrite</label>
            <div class="field-control">
              <label class="toggle-label">
                <input type="checkbox" name="notifyOnPreferenceOverwrite" [(ngModel)]="notifyOnPreferenceOverwrite" />
                <span class="toggle-text">{{ notifyOnPreferenceOverwrite ? 'Yes' : 'No' }}</span>
              </label>
            </div>
          </div>
        </div>

        <!-- Desktop settings (legacy) -->
        <div class="settings-section">
          <div class="section-title">Desktop Settings <span class="section-note">(synced to desktop app)</span></div>

          <div class="field-row">
            <label class="field-label">Fiber Timer</label>
            <div class="field-control inline-unit">
              <input type="number" name="fiberTimer" [(ngModel)]="fiberTimer" class="number-input" min="1" />
              <span class="range-unit">seconds</span>
            </div>
          </div>

          <div class="field-row">
            <label class="field-label">Wizard Template</label>
            <div class="field-control">
              <input type="text" name="wizardTemplateId" [(ngModel)]="wizardTemplateId" class="text-input" placeholder="Template ID (optional)" />
            </div>
          </div>
        </div>

        <div class="form-actions">
          <button type="submit" class="btn-primary" [disabled]="userSaveStatus === 'saving'">
            {{ userSaveStatus === 'saving' ? 'Saving…' : 'Save My Preferences' }}
          </button>
        </div>
        <div class="status-banner success" *ngIf="userSaveStatus === 'success'">Preferences saved.</div>
        <div class="status-banner error"   *ngIf="userSaveStatus === 'error'">{{ userErrorMessage }}</div>
      </form>
    </div>

    <!-- ═══════════════════ COMPANY SETTINGS ═══════════════════ -->
    <div class="panel" *ngIf="activeTab === 'company' && (isAdmin || isSuperAdmin)">
      <form (ngSubmit)="submitCompany()" #companyPrefForm="ngForm">

        <!-- Company identity -->
        <div class="settings-section">
          <div class="section-title">Company</div>
          <div class="field-row">
            <label class="field-label">Name</label>
            <div class="field-control"><span class="readonly-value">{{ companyName || '—' }}</span></div>
          </div>
        </div>

        <!-- Branding -->
        <div class="settings-section">
          <div class="section-title">Branding</div>

          <div class="logo-area">
            <div class="logo-preview-wrap" *ngIf="logoPreviewUrl || currentLogoUrl">
              <img [src]="logoPreviewUrl || currentLogoUrl" alt="Brand logo" class="logo-preview" />
              <span class="logo-preview-label" *ngIf="logoPreviewUrl">Preview — not yet uploaded</span>
            </div>
            <div class="logo-no-preview" *ngIf="!logoPreviewUrl && !currentLogoUrl">No logo set</div>
            <div class="logo-upload-row">
              <label class="file-btn">
                <input type="file" accept="image/*" (change)="onLogoSelected($event)" style="display:none" />
                Choose File
              </label>
              <span class="file-name">{{ selectedLogoFile ? selectedLogoFile.name : 'No file chosen' }}</span>
              <button type="button" class="btn-primary" (click)="uploadLogo()" [disabled]="!selectedLogoFile || logoUploadStatus === 'uploading'">
                {{ logoUploadStatus === 'uploading' ? 'Uploading…' : 'Upload Logo' }}
              </button>
            </div>
            <div class="status-banner success" *ngIf="logoUploadStatus === 'success'">Logo uploaded.</div>
            <div class="status-banner error"   *ngIf="logoErrorMessage">{{ logoErrorMessage }}</div>
          </div>

          <div class="field-row">
            <label class="field-label">Primary Color</label>
            <div class="field-control color-row">
              <input type="color" name="cPrimaryColor" [(ngModel)]="cPrimaryColor" class="color-input" />
              <input type="text"  name="cPrimaryColorHex" [(ngModel)]="cPrimaryColor" class="text-input color-hex" placeholder="#1a73e8" />
            </div>
          </div>

          <div class="field-row">
            <label class="field-label">Brand Description</label>
            <div class="field-control">
              <textarea name="cBrandingDescription" [(ngModel)]="cBrandingDescription" class="textarea-input" rows="2" placeholder="Shown in reports and admin screens"></textarea>
            </div>
          </div>

          <div class="field-row">
            <label class="field-label">Report Footer</label>
            <div class="field-control">
              <textarea name="cExportReportFooterText" [(ngModel)]="cExportReportFooterText" class="textarea-input" rows="2" placeholder="Footer text for PDF reports"></textarea>
            </div>
          </div>
        </div>

        <!-- Localization defaults -->
        <div class="settings-section">
          <div class="section-title">Localization Defaults</div>
          <p class="section-note-block">Toggle the lock to prevent users from overriding these settings.</p>

          <div class="field-row">
            <label class="field-label">Language</label>
            <div class="field-control with-lock">
              <select name="cDefaultLanguage" [(ngModel)]="cDefaultLanguage" class="select-input">
                <option *ngFor="let l of languageOptions" [value]="l.value">{{ l.label }}</option>
              </select>
              <label class="lock-toggle" title="Lock this setting for all users">
                <input type="checkbox" [(ngModel)]="cLanguageLocked" name="cLanguageLocked" />
                <span class="lock-toggle-label">{{ cLanguageLocked ? '🔒 Locked' : '🔓 Unlocked' }}</span>
              </label>
            </div>
          </div>

          <div class="field-row">
            <label class="field-label">Measurement</label>
            <div class="field-control with-lock">
              <div class="radio-group">
                <label class="radio-label"><input type="radio" name="cDefaultMeasurementSystem" value="metric"   [(ngModel)]="cDefaultMeasurementSystem" /> Metric</label>
                <label class="radio-label"><input type="radio" name="cDefaultMeasurementSystem" value="imperial" [(ngModel)]="cDefaultMeasurementSystem" /> Imperial</label>
              </div>
              <label class="lock-toggle">
                <input type="checkbox" [(ngModel)]="cMeasurementSystemLocked" name="cMeasurementSystemLocked" />
                <span class="lock-toggle-label">{{ cMeasurementSystemLocked ? '🔒 Locked' : '🔓 Unlocked' }}</span>
              </label>
            </div>
          </div>

          <div class="field-row">
            <label class="field-label">Time Format</label>
            <div class="field-control with-lock">
              <input type="text" name="cTimeFormat" [(ngModel)]="cTimeFormat" class="text-input" placeholder="HH:mm:ss" />
              <label class="lock-toggle">
                <input type="checkbox" [(ngModel)]="cTimeFormatLocked" name="cTimeFormatLocked" />
                <span class="lock-toggle-label">{{ cTimeFormatLocked ? '🔒 Locked' : '🔓 Unlocked' }}</span>
              </label>
            </div>
          </div>

          <div class="field-row">
            <label class="field-label">Date Format</label>
            <div class="field-control with-lock">
              <input type="text" name="cDateFormat" [(ngModel)]="cDateFormat" class="text-input" placeholder="yyyy-MM-dd" />
              <label class="lock-toggle">
                <input type="checkbox" [(ngModel)]="cDateFormatLocked" name="cDateFormatLocked" />
                <span class="lock-toggle-label">{{ cDateFormatLocked ? '🔒 Locked' : '🔓 Unlocked' }}</span>
              </label>
            </div>
          </div>
        </div>

        <!-- Chart defaults -->
        <div class="settings-section">
          <div class="section-title">Chart Defaults</div>

          <div class="field-row">
            <label class="field-label">3D Temp Range</label>
            <div class="field-control with-lock">
              <div class="range-row">
                <label class="range-label">Min</label>
                <input type="number" name="cDefault3DTempMin" [(ngModel)]="cDefault3DTempMin" class="number-input" />
                <span class="range-unit">°C</span>
                <label class="range-label">Max</label>
                <input type="number" name="cDefault3DTempMax" [(ngModel)]="cDefault3DTempMax" class="number-input" />
                <span class="range-unit">°C</span>
              </div>
              <label class="lock-toggle">
                <input type="checkbox" [(ngModel)]="cTemp3DLocked" name="cTemp3DLocked" />
                <span class="lock-toggle-label">{{ cTemp3DLocked ? '🔒 Locked' : '🔓 Unlocked' }}</span>
              </label>
            </div>
          </div>

          <div class="field-row">
            <label class="field-label">3D Time Mode</label>
            <div class="field-control">
              <div class="radio-group">
                <label class="radio-label"><input type="radio" name="cDefault3DTimeMode" value="relative" [(ngModel)]="cDefault3DTimeMode" /> Relative</label>
                <label class="radio-label"><input type="radio" name="cDefault3DTimeMode" value="absolute" [(ngModel)]="cDefault3DTimeMode" /> Absolute</label>
              </div>
            </div>
          </div>

          <div class="field-row">
            <label class="field-label">Color Palette</label>
            <div class="field-control with-lock">
              <select name="cDefaultChartsColorPalette" [(ngModel)]="cDefaultChartsColorPalette" class="select-input">
                <option *ngFor="let p of colorPaletteOptions" [value]="p.value">{{ p.label }}</option>
              </select>
              <label class="lock-toggle">
                <input type="checkbox" [(ngModel)]="cChartsColorPaletteLocked" name="cChartsColorPaletteLocked" />
                <span class="lock-toggle-label">{{ cChartsColorPaletteLocked ? '🔒 Locked' : '🔓 Unlocked' }}</span>
              </label>
            </div>
          </div>

          <div class="field-row">
            <label class="field-label">Default Fiber Timer</label>
            <div class="field-control inline-unit">
              <input type="number" name="cDefaultFiberTimer" [(ngModel)]="cDefaultFiberTimer" class="number-input" min="1" />
              <span class="range-unit">seconds</span>
            </div>
          </div>
        </div>

        <!-- Notifications defaults -->
        <div class="settings-section">
          <div class="section-title">Notification Defaults</div>

          <div class="field-row">
            <label class="field-label">Email alerts</label>
            <div class="field-control with-lock">
              <label class="toggle-label">
                <input type="checkbox" name="cNotificationsEmailEnabled" [(ngModel)]="cNotificationsEmailEnabled" />
                <span class="toggle-text">{{ cNotificationsEmailEnabled ? 'Enabled' : 'Disabled' }}</span>
              </label>
              <label class="lock-toggle">
                <input type="checkbox" [(ngModel)]="cNotificationsEmailLocked" name="cNotificationsEmailLocked" />
                <span class="lock-toggle-label">{{ cNotificationsEmailLocked ? '🔒 Locked' : '🔓 Unlocked' }}</span>
              </label>
            </div>
          </div>

          <div class="field-row">
            <label class="field-label">Realtime alerts</label>
            <div class="field-control with-lock">
              <label class="toggle-label">
                <input type="checkbox" name="cNotificationsRealtimeAlerts" [(ngModel)]="cNotificationsRealtimeAlerts" />
                <span class="toggle-text">{{ cNotificationsRealtimeAlerts ? 'Enabled' : 'Disabled' }}</span>
              </label>
              <label class="lock-toggle">
                <input type="checkbox" [(ngModel)]="cNotificationsRealtimeLocked" name="cNotificationsRealtimeLocked" />
                <span class="lock-toggle-label">{{ cNotificationsRealtimeLocked ? '🔒 Locked' : '🔓 Unlocked' }}</span>
              </label>
            </div>
          </div>
        </div>

        <!-- Security -->
        <div class="settings-section">
          <div class="section-title">Security</div>

          <div class="field-row">
            <label class="field-label">Session Timeout</label>
            <div class="field-control inline-unit">
              <input type="number" name="cSecuritySessionTimeoutMinutes" [(ngModel)]="cSecuritySessionTimeoutMinutes" class="number-input" min="5" max="1440" />
              <span class="range-unit">minutes</span>
            </div>
          </div>

          <div class="field-row">
            <label class="field-label">Require MFA</label>
            <div class="field-control">
              <label class="toggle-label">
                <input type="checkbox" name="cSecurityRequireMfa" [(ngModel)]="cSecurityRequireMfa" />
                <span class="toggle-text">{{ cSecurityRequireMfa ? 'Required' : 'Not required' }}</span>
              </label>
            </div>
          </div>
        </div>

        <!-- Subscriptions -->
        <div class="settings-section">
          <div class="section-title">Subscriptions</div>

          <div class="field-row">
            <label class="field-label">Hybrid streaming</label>
            <div class="field-control">
              <label class="toggle-label">
                <input type="checkbox" name="cHybridStreamingEnabled" [(ngModel)]="cHybridStreamingEnabled" />
                <span class="toggle-text">{{ cHybridStreamingEnabled ? 'Enabled' : 'Disabled' }}</span>
              </label>
            </div>
          </div>
        </div>

        <div class="form-actions">
          <button type="submit" class="btn-primary" [disabled]="companySaveStatus === 'saving'">
            {{ companySaveStatus === 'saving' ? 'Saving…' : 'Save Company Settings' }}
          </button>
        </div>
        <div class="status-banner success" *ngIf="companySaveStatus === 'success'">Company settings saved.</div>
        <div class="status-banner error"   *ngIf="companySaveStatus === 'error'">{{ companyErrorMessage }}</div>
      </form>
    </div>

  </div>
</div>
